// @flow
import React, { Component } from "react";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import { withStyles } from "@material-ui/core/styles";

import type { DictionaryType } from "../../types/GeneralTypes";

const styles = (theme: DictionaryType): DictionaryType => ({
  switchBase: {
    color: theme.palette.common.white,
    "&$checked": {
      color: theme.palette.primary.main,
      "& + $bar": {
        backgroundColor: theme.palette.primary.main
      }
    }
  },
  checked: {},
  bar: {}
});

type SingleSwitchClassesType = {
  switchBase: DictionaryType,
  checked: DictionaryType,
  bar: DictionaryType
};

type SingleSwitchPropsType = {
  classes: SingleSwitchClassesType,
  value: boolean,
  name: string,
  handleChange: Function,
  label: Array<string> | string,
  isRequired?: boolean,
  isDisabled?: boolean
};

class SingleSwitch extends Component<SingleSwitchPropsType, *> {
  render(): * {
    const classes = this.props.classes;

    let label = "";
    if (typeof this.props.label === "string") {
      label = this.props.label;
    } else {
      label = this.props.value ? this.props.label[0] : this.props.label[1];
    }
    return (
      <FormControlLabel
        control={
          <Switch
            checked={this.props.value}
            color="primary"
            onChange={this.props.handleChange}
            id={this.props.name}
            name={this.props.name}
            value="true"
            inputProps={{
              required: this.props.isRequired
            }}
            disabled={this.props.isDisabled}
            classes={{
              switchBase: classes.switchBase,
              checked: classes.checked,
              bar: classes.bar
            }}
          />
        }
        label={label}
      />
    );
  }
}

export default withStyles(styles)(SingleSwitch);
